import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsAfter } from "../../dateutil";
import moment from 'moment-timezone';

class AfterTimeEx extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      const beginningTime = fieldResponse.currentValue;
      const endTime = validation.value;
      let current = moment(beginningTime, 'h:mma').format('YYYY-MM-DD HH:mm');
      let compare = moment(endTime, 'h:mma').format('YYYY-MM-DD HH:mm');
      if ( !dateIsAfter(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_AFTER_SPECIFIED_DATE_EX',
          values: { value: validation.value },
          message: `Value should be after '${validation.value}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default AfterTimeEx;
